export enum LogAction {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
  EXPIRED = 'expired'
}

export enum LogType {
  TASK = 'task',
  OPPORTUNITY_CHANGE = 'opportunity_change',
  LEAD_CHANGE = 'lead_change',
  CALL = 'call',
  EMAIL = 'email',
  MEETING = 'meeting',
  NOTE = 'note',
  CHAT = 'chat',
  LEAD_SEQUENCE_CHANGE = 'lead_sequence_change',
  ERROR = 'error'
}
